<div class="w-100 float-left pl-5" *ngFor="let childOperation of childOperation;index as i">
    <operation [operation]='childOperation' i='{{childOperation.operation}}'
               (selected)="select($event,childOperation)"></operation>
</div>


// WEBPACK FOOTER //
// ./src/app/tools/rolesAndPermission/childOperations.html